import React from 'react'

import { useFirestoreConnect } from 'react-redux-firebase'

import { useSelector } from 'react-redux'
import { selectAccountHash } from '@selectors'

import SafeWalkV1 from '@components/safewalk-v1/safewalk-v1.component'
import CustomAlertV1 from '@components/custom-alert-v1/custom-alert-v1.component'
import Noaa from '@components/noaa/noaa.component'
import PanicButton from '@components/panic-button/panic-button.component'
import PriorityConnectV1 from '@components/priority-connect-v1/priority-connect-v1.component'
import ReferenceLoader from '@components/reference-loader/reference-loader.component'
import SearchLight from '@components/searchlight/searchlight.component'
import SearchlightV2 from '@components/searchlight-v2/searchlight-v2.component'
import TipPriority from '@components/tip-priority/tip-priority.component'

const ChatMessageReference = props => {
  const { message } = props

  const accountHash = useSelector(selectAccountHash)
  const { collection, documentId } = message

  const tipRef = `tip-v1/${accountHash}/reference`
  const safeWalkRef = `safe-walk-v1/${accountHash}/reference`

  const tip = useSelector(({ firestore: { data } }) => data[tipRef] && data[tipRef][documentId])

  const safewalk = useSelector(({ firestore: { data } }) => data[safeWalkRef] && data[safeWalkRef][documentId])

  const ref = useSelector(({ firestore: { data } }) => data[collection] && data[collection][documentId])

  const checkFirebaseCollection = () => {
    switch (collection) {
    case 'tip-v1':
      return { document: tip, filteredCollection: tipRef }
    case 'safe-walk-v1':
      return { document: safewalk, filteredCollection: safeWalkRef }
    default:
      return { document: ref, filteredCollection: collection }
    }
  }

  const { document, filteredCollection } = checkFirebaseCollection()

  useFirestoreConnect([
    {
      collection: filteredCollection,
      doc: documentId
    }
  ])

  if (!document) {
    return <ReferenceLoader />
  }

  switch (collection) {
  case 'custom-v1':
    return <CustomAlertV1 {...props} />
  case 'noaa-v1':
    return <Noaa {...props} />
  case 'panicbutton-v1':
    return <PanicButton {...props} />
  case 'priority-connect':
    return <PriorityConnectV1 {...props} />
  case 'searchlight-v1':
    return <SearchLight {...props} />
  case 'searchlight-v2':
    return <SearchlightV2 {...props} />
  case 'tip-v1':
    return <TipPriority {...props} />
  case 'safe-walk-v1':
    return <SafeWalkV1 {...props} />
  default:
    return null
  }
}

export default ChatMessageReference
